module.exports = __webpack_public_path__ + "static/img/2.e2eeb541.png";